import angular from 'angular';

angular
  .module('cxHttpServices')
  .factory('externalRelationHttpSvc', ['$http', 'appUrls', externalRelationHttpSvc]);

function externalRelationHttpSvc($http, appUrls) {
  var baseUrl = appUrls.api + '/api/externalRelation/';

  function handleSuccess(response) {
    return response.data;
  }

  return {
    search: function(value, take, searchProvider, companyId, cancelPromise) {
      var options = {};
      if (typeof cancelPromise != 'undefined') options.timeout = cancelPromise;
      return $http
        .get(
          baseUrl +
            'search/?id=' +
            encodeURIComponent(value) +
            '&take=' +
            (take || 20) +
            '&searchProvider=' +
            searchProvider +
            '&companyId=' +
            companyId,
          options,
        )
        .then(handleSuccess);
    },
    details: function(uniqueIdentifier, searchProvider) {
      return $http
        .get(baseUrl + 'details?id=' + uniqueIdentifier + '&searchProvider=' + searchProvider)
        .then(handleSuccess);
    },
    create: function(model) {
      return $http.post(baseUrl + 'create', model).then(handleSuccess); //...which contains dots that are interpreted as an extension.
    },
  };
}
